import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { VALIDATION_COMPONENT_TYPE_ENUM } from '../../validation.component';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { MODAL, ModalService } from 'src/app/services/modal.service';
import { StatisticTypeEnum } from 'src/app/enum/statistic-type.enum';
import { FidelityCardValidationModel } from 'src/app/models/configurators-2d/applications/kitchen/validation/base-validation-project-info';
import { KitchenValidationProjectInfoModel } from 'src/app/models/configurators-2d/applications/kitchen/validation/kitchen-validation-models';

@Component({
  selector: 'ng-kitchen-validation-project-info',
  templateUrl: './validation-project-info.component.html',
})
export class KitchenValidationProjectInfoComponent implements OnInit, OnDestroy {
  @Input() model$: Observable<KitchenValidationProjectInfoModel>;
  private _modelSubscription: Subscription;

  @Input() loading$: Observable<boolean>;
  private _loadingSubscription: Subscription;

  @Output() onRefreshRequested: EventEmitter<VALIDATION_COMPONENT_TYPE_ENUM> = new EventEmitter();

  private readonly renderPlaceholderUrl: string = 'assets/img/placeholders/hqrenders.jpg';

  public model: KitchenValidationProjectInfoModel;
  public loading: boolean;
  public fidelityCardValidationModel: BehaviorSubject<FidelityCardValidationModel> =
    new BehaviorSubject<FidelityCardValidationModel>(undefined);

  public faSearch = faSearch;

  onError(event: Event) {
    (event.target as HTMLImageElement).src = this.renderPlaceholderUrl;
  }

  constructor(private readonly injector: Injector) {}

  ngOnInit(): void {
    this.subscribeToObservables();
  }

  ngOnDestroy(): void {
    this._modelSubscription?.unsubscribe();
    this._loadingSubscription?.unsubscribe();
  }

  private buildFidelityCardValidationModel() {
    this.fidelityCardValidationModel.next(this.model?.fidelityCardValidationModel);
  }

  private subscribeToObservables() {
    this._modelSubscription = this.model$.subscribe(model => {
      if (model) {
        this.model = model;
        this.buildFidelityCardValidationModel();
      }
    });

    this._loadingSubscription = this.loading$.subscribe(loading => (this.loading = loading));
  }

  refresh() {
    this.onRefreshRequested.emit();
  }

  openDetailCustomer() {
    const modalService = this.injector.get(ModalService);
    modalService.display(MODAL.REGISTER, {
      defaultEmail: this.model.customer.email,
      loadData: true,
      updateData: true,
      updateDataValidation: true,
      statisticType: StatisticTypeEnum.NEW_FREE_CARD_VALIDATION,
      registerCallback: () => {
        modalService.display(MODAL.NONE);
        this.refresh();
      },
    });
  }
}
